module.exports = __webpack_public_path__ + "img/it.ff407033.svg";